import { FC, memo } from "react";
import useI18n from "../../../hooks/useTranslations";
import styles from "./ConcreteResinPreview.module.css";

const ConcreteResinPreview: FC = () => {
  const i18n = useI18n();

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <img
          src="/concreteResin/instructions-preview-resin-quantity.png"
          alt={i18n.translation.common.preview}
          className={styles.background}
        />
      </div>
    </div>
  );
};

export default memo(ConcreteResinPreview);
